import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "close-button"

  connect() {
    super.connect()
    this.send("connect", {})
  }
}
